export default {"src":"/education/_next/static/media/crown-school.4440e7ab.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};